import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import './types.d'

import App from './App'
// import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from 'styled-components'
import theme from './theme'
import { ConfigProvider } from 'antd'

import './test'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container: HTMLElement = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ConfigProvider
          form={{
            validateMessages: {
              required: 'Required',
            },
          }}
        >
          <App />
        </ConfigProvider>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
